var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "go-comments-title" }, [
    _c("strong", [_vm._v(_vm._s(_vm.$t("report.comments")))]),
    _vm._v(" "),
    _c("span", [_vm._t("total")], 2),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }